import { render } from "./ClientSkinPicker.vue?vue&type=template&id=45bf06a3&scoped=true&ts=true"
import script from "./ClientSkinPicker.vue?vue&type=script&lang=ts"
export * from "./ClientSkinPicker.vue?vue&type=script&lang=ts"

import "./ClientSkinPicker.vue?vue&type=style&index=0&id=45bf06a3&scoped=true&lang=css"

import exportComponent from "G:\\IT\\landiyun4.0\\ldcustomer\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45bf06a3"]])

export default __exports__